export default __webpack_public_path__ + "fonts/Gotham-Medium.b0a210b62578395fb22ff3b889dcf68c.otf";